<template>
  <div class="Crisis_evaluation_view">
    <el-descriptions class="margin-top" :column="4"  border>

      <el-descriptions-item>
        <template slot="label">
          姓名
        </template>
        {{ datas.RealName }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          性别
        </template>
        {{ sex == 1?'男':'女' }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          年龄
        </template>
        {{ age }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          学号
        </template>
        {{ userId }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          近期情绪状态如何
        </template>
        {{ sys_Forms[1].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          持续时间
        </template>
        {{ sys_Forms[2].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          现实事件刺激影响
        </template>
        {{ sys_Forms[5].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          有无自杀自伤想法或行为
        </template>
        <div v-for="(item, i) in sys_Forms[7].Bobbies" :key="i">
          <span v-if="sys_Forms[7].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">
          自杀自伤想法或行为
        </template>
        {{ sys_Forms[7].Bobbies[1].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          保护因素
        </template>
        {{ sys_Forms[8].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          自杀危机状态
        </template>
        <div v-for="(item, i) in sys_Forms[9].Bobbies" :key="i">
          <span v-if="sys_Forms[9].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          精神疾病治疗史
        </template>
        <div v-for="(item, i) in sys_Forms[12].Bobbies" :key="i">
          <span v-if="sys_Forms[12].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">诊断结果</template>
        {{ sys_Forms[13].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">治疗情况</template>
        {{ sys_Forms[14].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">家族史</template>
        {{ sys_Forms[15].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">是否有物质依赖</template>
        <div v-for="(item, i) in sys_Forms[16].Bobbies" :key="i">
          <span v-if="sys_Forms[16].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">是否愿意寻求心理咨询帮助</template>
        {{ sys_Forms[18].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">是否愿意就医</template>
        {{ sys_Forms[19].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">备注</template>
        {{ sys_Forms[20].FormValue }}
      </el-descriptions-item>
      
      <el-descriptions-item span="1">
        <template slot="label">访谈后风险等级</template>
        <div v-for="(item, i) in sys_Forms[22].Bobbies" :key="i">
          <span v-if="sys_Forms[22].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item> 

      <el-descriptions-item span="3">
        <template slot="label">风险调整原因</template>
        {{ sys_Forms[23].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">访谈建议</template>
        {{ sys_Forms[25].FormValue }}
      </el-descriptions-item>

    </el-descriptions>

    <!-- 初评危机状态 -->
    <div class="cpwjzt" style="display: block; width: 98%; margin-left: 1%; margin-top: 20px;">
      <label style="display: block; margin-bottom: 10px;">
        <span><i style="color: red">*</i> 初评危机状态</span>
      </label>
      <el-radio v-model="firstCrisis" label="1" :disabled="!firstCrisisEditable">红色预警</el-radio>
      <el-radio v-model="firstCrisis" label="2" :disabled="!firstCrisisEditable">橙色预警</el-radio>
      <el-radio v-model="firstCrisis" label="3" :disabled="!firstCrisisEditable">黄色预警</el-radio>
      <el-radio v-model="firstCrisis" label="4" :disabled="!firstCrisisEditable">蓝色预警</el-radio>
      <el-radio v-model="firstCrisis" label="5" :disabled="!firstCrisisEditable">绿色预警</el-radio>
      <el-radio v-model="firstCrisis" label="6" :disabled="!firstCrisisEditable">无法确定</el-radio>
    </div>

    <!-- 审核内容输入框（按角色显示，编辑者可写，其它角色只读） -->
    <!-- 风险监控员审核内容 -->
    <div v-if="showRiskMonitorReview" class="nkjs" style="display: block; width: 98%; margin-left: 1%; margin-top: 20px;">
      <label style="display: block; margin-bottom: 10px;">风险监控员审核内容</label>
      <el-input 
        type="textarea" 
        v-model="riskMonitorReviewDetail" 
        :disabled="disabledRiskMonitorReview"
        :placeholder="disabledRiskMonitorReview ? '' : '请输入风险监控员审核内容'">
      </el-input>
    </div>
    
    <!-- 危机主管审核内容 -->
    <div v-if="showCriAdminReview" class="nkjs" style="display: block; width: 98%; margin-left: 1%; margin-top: 20px;">
      <label style="display: block; margin-bottom: 10px;">危机主管审核内容</label>
      <el-input 
        type="textarea" 
        v-model="criAdminReviewDetail" 
        :disabled="disabledCriAdminReview"
        :placeholder="disabledCriAdminReview ? '' : '请输入危机主管审核内容'">
      </el-input>
    </div>
    
    <!-- 中心主任审核内容 -->
    <div v-if="showCenterDirectorReview" class="nkjs" style="display: block; width: 98%; margin-left: 1%; margin-top: 20px;">
      <label style="display: block; margin-bottom: 10px;">中心主任审核内容</label>
      <el-input 
        type="textarea" 
        v-model="centerDirectorReviewDetail" 
        :disabled="disabledCenterDirectorReview"
        :placeholder="disabledCenterDirectorReview ? '' : '请输入中心主任审核内容'">
      </el-input>
    </div>

    <!-- 办理内容输入框 -->
    <!-- type=2时：1068和1069可以看到两个输入框，但只能编辑自己的内容，另一个是查看显示 -->
    <!-- type不传值时：1068、1069、1070可以看到两个输入框，有内容就显示，没有就隐藏，都是只读 -->
    
    <!-- 危机主管办理内容 -->
    <div v-if="showCrisisAdminHandleContentDisplay" class="nkjs" style="display: block; width: 98%; margin-left: 1%; margin-top: 20px;">
      <label style="display: block; margin-bottom: 10px;">危机主管办理内容</label>
      <el-input 
        type="textarea" 
        v-model="criAdminHandleDetail" 
        :disabled="!canEditCrisisAdminHandleContent"
        :placeholder="canEditCrisisAdminHandleContent ? '请输入危机主管办理内容' : ''" >
      </el-input>
    </div>
    
    <!-- 风险监控员办理内容 -->
    <div v-if="showRiskMonitorHandleContentDisplay" class="nkjs" style="display: block; width: 98%; margin-left: 1%; margin-top: 20px;">
      <label style="display: block; margin-bottom: 10px;">风险监控员办理内容</label>
      <el-input 
        type="textarea" 
        v-model="riskMonitorHandleDetail" 
        :disabled="!canEditRiskMonitorHandleContent"
        :placeholder="canEditRiskMonitorHandleContent ? '请输入风险监控员办理内容' : ''" >
      </el-input>
    </div>
    
    <!-- 办理提交按钮（type=2时显示） -->
    <div v-if="showHandleSubmitBtn" style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
      <el-button type="primary" @click="handleHandleSubmit()">确认</el-button>
    </div>
    
    <!-- 按钮区域 -->
    <div style="text-align: center; margin-top: 20px; margin-bottom: 20px;">
      <!-- 1063: 只显示提交按钮 -->
      <el-button v-if="showSubmitBtn" type="primary" @click="handleSubmit('1')">提交</el-button>
      
      <!-- 1069、1068、1070: 显示提交和驳回按钮 -->
      <template v-if="showSubmitAndRejectBtns">
        <!-- 1068 + 初评「无法确定」(label=6)：仅驳回 + 提交咨询主管（与 Crisis_lookreport 一致） -->
        <template v-if="showCrisisAdminConsultDirectorBtns">
          <el-button type="danger" @click="handleReject">驳回</el-button>
          <el-button type="primary" @click="handleSubmit('4')" style="margin-left: 30px;">提交咨询主管</el-button>
        </template>
        <template v-else>
          <el-button type="danger" @click="handleReject">驳回</el-button>
          <el-button type="primary" @click="handleSubmit('1')" style="margin-left: 30px;">{{ auditPrimarySubmitText }}</el-button>
        </template>
      </template>
    
      <!-- 1068: 显示审核确认（初评非「无法确定」时） -->
      <el-button v-if="showFinalSubmitBtn" type="success" @click="handleSubmit('2')" style="margin-left: 30px;">审核确认</el-button>
    </div>

    <!-- 返回按钮只在查看时显示（type不传值或为空） -->
    <div v-if="!type || type === ''" style="padding-bottom: 20px;text-align: center;">
      <el-button @click="$router.go(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nxkos: [
        { "Value": "PTIR0301001", "FormValue": "", "Name": "无", "FontColor": null, "Display": false },
        { "Value": "PTIR0301002", "FormValue": "", "Name": "有", "FontColor": null, "Display": true }
      ],
      age: '',
      sex: '',
      userId: '',
      PublishID:'',
      UserID: '',
      datas: '',
      keyNo: '',
      sys_Forms: [],
      roleID: '',
      type: '',
      firstCrisisEditable: false, // 控制firstCrisis是否可编辑，默认不可编辑
      firstCrisis: '', // 初评危机状态
      criAdminHandleDetail: '', // 危机主管办理内容（1068）
      riskMonitorHandleDetail: '', // 风险监控员办理内容（1069）
      // 审核内容（type=1）
      riskMonitorReviewDetail: '', // 风险监控员审核内容（1069）
      criAdminReviewDetail: '', // 危机主管审核内容（1068）
      centerDirectorReviewDetail: '', // 中心主任审核内容（1070）
    }
  },
  computed: {
    // 判断是否显示提交按钮（1063显示）
    showSubmitBtn() {
      return this.roleID && this.roleID.indexOf('1063') !== -1 && this.type === '1';
    },
    // 判断是否显示提交和驳回按钮（1069、1068、1070显示）
    showSubmitAndRejectBtns() {
      if (this.type !== '1') return false;
      const roles = ['1069', '1068', '1070'];
      return roles.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
    },
    // 1068 + 审核 + 初评「无法确定」：走驳回/提交咨询主管，不显示审核确认（与 Crisis_lookreport 一致）
    showCrisisAdminConsultDirectorBtns() {
      return (
        this.type === '1' &&
        this.roleID &&
        this.roleID.indexOf('1068') !== -1 &&
        this.firstCrisis === '6'
      );
    },
    // 审核(type=1)主提交按钮文案：1069=提交危机主管；1068=提交中心主任；默认=审核确认
    auditPrimarySubmitText() {
      if (!this.roleID) return '审核确认';
      if (this.roleID.indexOf('1069') !== -1) return '提交危机主管';
      if (this.roleID.indexOf('1068') !== -1) return '提交中心主任';
      return '审核确认';
    },
    // 判断是否显示审核确认按钮（1068 显示，初评为无法确定时不显示）
    showFinalSubmitBtn() {
      return (
        this.roleID &&
        this.roleID.indexOf('1068') !== -1 &&
        this.type === '1' &&
        this.firstCrisis !== '6'
      );
    },
    // 判断是否显示危机主管办理内容输入框
    // type=2时：1068和1069都显示
    // type不传值时：1068、1069、1070显示，但需要有内容才显示
    showCrisisAdminHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
               (this.roleID && this.roleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        const hasRole = (this.roleID && this.roleID.indexOf('1068') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1069') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1070') !== -1);
        return hasRole && this.criAdminHandleDetail && this.criAdminHandleDetail.trim();
      }
      return false;
    },
    // 判断是否显示风险监控员办理内容输入框
    // type=2时：1068和1069都显示
    // type不传值时：1068、1069、1070显示，但需要有内容才显示
    showRiskMonitorHandleContentDisplay() {
      if (this.type === '2') {
        // type=2时，1068和1069都显示
        return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
               (this.roleID && this.roleID.indexOf('1069') !== -1);
      } else if (!this.type || this.type === '') {
        // type不传值时，1068、1069、1070显示，但需要有内容才显示
        const hasRole = (this.roleID && this.roleID.indexOf('1068') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1069') !== -1) ||
                        (this.roleID && this.roleID.indexOf('1070') !== -1);
        return hasRole && this.riskMonitorHandleDetail && this.riskMonitorHandleDetail.trim();
      }
      return false;
    },
    // 判断是否可以编辑危机主管办理内容（type=2时，只有1068可以编辑）
    canEditCrisisAdminHandleContent() {
      return this.type === '2' && this.roleID && this.roleID.indexOf('1068') !== -1;
    },
    // 判断是否可以编辑风险监控员办理内容（type=2时，只有1069可以编辑）
    canEditRiskMonitorHandleContent() {
      return this.type === '2' && this.roleID && this.roleID.indexOf('1069') !== -1;
    },
    // 判断是否显示办理提交按钮（type=2时，1068或1069显示）
    showHandleSubmitBtn() {
      if (this.type !== '2') return false;
      return (this.roleID && this.roleID.indexOf('1068') !== -1) || 
             (this.roleID && this.roleID.indexOf('1069') !== -1);
    },
    // 审核与查看/办理场景下三类审核内容的显示与禁用控制
    showRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledRiskMonitorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1069') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
    showCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCriAdminReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1068') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
    showCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      const isView = !this.type || (this.type !== '1' && this.type !== '2');
      const hasAuditRole = this.roleID && (this.roleID.indexOf('1070') !== -1);
      const canView = this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1 || this.roleID.indexOf('1070') !== -1 || this.roleID.indexOf('1063') !== -1);
      const isHandleViewer = isHandle && this.roleID && (this.roleID.indexOf('1068') !== -1 || this.roleID.indexOf('1069') !== -1);
      return (isAudit && hasAuditRole) || (isView && canView) || isHandleViewer;
    },
    disabledCenterDirectorReview() {
      const isAudit = this.type === '1';
      const isHandle = this.type === '2';
      if (isAudit) {
        return !(this.roleID && this.roleID.indexOf('1070') !== -1);
      }
      if (isHandle) {
        return true; // 办理阶段仅查看
      }
      return true; // 查看阶段只读
    },
  },
  methods: {
    // 驳回处理（带确认提示）
    handleReject() {
      this.$confirm('确认驳回该申请吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleSubmit('0');
      }).catch(() => {
        // 用户取消操作
      });
    },
    // 提交/驳回处理
    handleSubmit(type) {
      // type: '0' 驳回, '1' 提交（按角色主流程）, '2' 审核确认(1068), '4' 提交咨询主管(1068+无法确定)
      // 验证 keyNo
      if (!this.keyNo) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      // 构建请求参数
      const params = {
        keyNo: this.keyNo,
        type: type, // 提交驳回标记
        sourceFlg: "4",//4：咨询上报
      };
      
      // 根据角色决定是否传初评危机状态
      const editableRoles = ['1063', '1069', '1068', '1070'];
      const canEdit = editableRoles.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
      
      if (canEdit && this.type === '1') {
        // 1063、1069、1068 传初评危机状态（仅在审核时）
        if (!this.firstCrisis || this.firstCrisis == '0') {
          this.$message.warning('请选择初评危机状态');
          return;
        }
        params.firstCrisis = this.firstCrisis;
      }
      
      // 审核(type=1)时附带对应角色的审核内容（若填写）
      if (this.type === '1') {
        if (this.roleID && this.roleID.indexOf('1069') !== -1 && this.riskMonitorReviewDetail && this.riskMonitorReviewDetail.trim()) {
          params.RiskMonitorReviewDetail = this.riskMonitorReviewDetail.trim();
        }
        if (this.roleID && this.roleID.indexOf('1068') !== -1 && this.criAdminReviewDetail && this.criAdminReviewDetail.trim()) {
          params.CriAdminReviewDetail = this.criAdminReviewDetail.trim();
        }
        if (this.roleID && this.roleID.indexOf('1070') !== -1 && this.centerDirectorReviewDetail && this.centerDirectorReviewDetail.trim()) {
          params.CenterDirectorReviewDetail = this.centerDirectorReviewDetail.trim();
        }
      }
      
      this.$Http_Post('/DistressPrediction/UpdateFirstCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '操作成功');
          // 可以返回上一页或刷新数据
          this.$router.go(-1);
        } else {
          this.$message.error(res.Message || '操作失败');
        }
      }).catch((err) => {
        this.$message.error('操作失败');
      });
    },
    // 办理提交处理（type=2时使用）
    handleHandleSubmit() {
      // 验证 keyNo
      if (!this.keyNo) {
        this.$message.warning('缺少关键参数');
        return;
      }
      
      // 构建请求参数
      const params = {
        keyNo: this.keyNo,
        type: '2', // 办理标记
      };
      
      // 根据角色添加不同的办理内容字段
      if (this.roleID && this.roleID.indexOf('1068') !== -1) {
        // 1068: 危机主管办理内容
        if (!this.criAdminHandleDetail || !this.criAdminHandleDetail.trim()) {
          this.$message.warning('请输入危机主管办理内容');
          return;
        }
        params.criAdminHandleDetail = this.criAdminHandleDetail.trim();
      } else if (this.roleID && this.roleID.indexOf('1069') !== -1) {
        // 1069: 风险监控员办理内容
        if (!this.riskMonitorHandleDetail || !this.riskMonitorHandleDetail.trim()) {
          this.$message.warning('请输入风险监控员办理内容');
          return;
        }
        params.riskMonitorHandleDetail = this.riskMonitorHandleDetail.trim();
      }
      
      this.$Http_Post('/DistressPrediction/HandleCrisis', params).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.$message.success(res.Message || '办理提交成功');
          // 可以返回上一页或刷新数据
          this.$router.go(-1);
        } else {
          this.$message.error(res.Message || '办理提交失败');
        }
      }).catch((err) => {
        this.$message.error('办理提交失败');
      });
    }
  },
  mounted() {
    // 获取角色ID
    this.roleID = sessionStorage.getItem("RoleID");
    
    this.PublishID = [this.$route.query.PublishID][0];
    this.UserID = [this.$route.query.UserID][0];
    this.keyNo = [this.$route.query.KeyNo][0];
    this.type = this.$route.query.type || '';
    
    // 审核(type=1)时：1063、1069、1068、1070 可编辑
    const editableRoleIDs = ['1063', '1069', '1068', '1070'];
    const hasEditableRole = editableRoleIDs.some(role => this.roleID && this.roleID.indexOf(role) !== -1);
    this.firstCrisisEditable = this.type === '1' && hasEditableRole;
    
    this.$Http_Post('/CrisisWarning/GetFormView', { TableName: "新生心理普测访谈记录表", PublishID: this.PublishID, UserID: this.UserID }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.datas = res.Data;
        this.sys_Forms = res.Data.sys_Forms;
      }
    });

    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', { keyNo: this.keyNo }).then((res) => {
      if (res.Code == 0) {
        this.age = res.Data.age;
        this.sex = res.Data.sex;
        this.userId = res.Data.userId;
        // 获取初评危机状态
        if (res.Data.firstCrisis !== undefined) {
          this.firstCrisis = res.Data.firstCrisis || '';
        }
        // 获取办理内容（如果接口返回了这些字段）
        if (res.Data.CriAdminHandleDetail !== undefined) {
          this.criAdminHandleDetail = res.Data.CriAdminHandleDetail || '';
        }
        if (res.Data.RiskMonitorHandleDetail !== undefined) {
          this.riskMonitorHandleDetail = res.Data.RiskMonitorHandleDetail || '';
        }
        // 回显审核内容（若接口返回）
        if (res.Data.RiskMonitorReviewDetail !== undefined) {
          this.riskMonitorReviewDetail = res.Data.RiskMonitorReviewDetail || '';
        }
        if (res.Data.CriAdminReviewDetail !== undefined) {
          this.criAdminReviewDetail = res.Data.CriAdminReviewDetail || '';
        }
        if (res.Data.CenterDirectorReviewDetail !== undefined) {
          this.centerDirectorReviewDetail = res.Data.CenterDirectorReviewDetail || '';
        }
      }
    });
  }
}

</script>

<style>
.Crisis_evaluation_view{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Crisis_evaluation_view .el-descriptions{width: 98%;margin-left: 1%;padding-top: 20px;}
.nkjs .el-textarea.is-disabled .el-textarea__inner {
  width: 100% !important;
  height: 80px;
}
.nkjs .el-textarea .el-textarea__inner {
  width: 100% !important;
  height: 80px;
}
.cpwjzt {
  display: block !important;
  width: 100% !important;
}
.cpwjzt .el-radio {
  margin-right: 20px;
}
</style>